import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaUserCircle } from 'react-icons/fa';
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { HueContext } from "../HueContext";
import { useContext } from "react";
import { endSpectraSession } from "../utils/session";
export default function NavBar({ username, balance }) {

const [menuOpen, setMenuOpen] = useState(false);
const [userMenuOpen, setUserMenuOpen] = useState(false);
const userMenuTimer = useRef(null);

const navigate = useNavigate();  // 👈 THIS LINE
const handleLogout = endSpectraSession;
const toggleMenu = () => setMenuOpen(!menuOpen);
const toggleUserMenu = () => {
  if (userMenuOpen) {
    clearTimeout(userMenuTimer.current);
    setUserMenuOpen(false);
  } else {
    setUserMenuOpen(true);
    userMenuTimer.current = setTimeout(() => setUserMenuOpen(false), 5000);
  }
};

const hue = useContext(HueContext);

const handleNavigation = (path) => {
  setMenuOpen(false);
  setUserMenuOpen(false);
  navigate(path);
};

  // Format balance safely
  const formattedBalance =
    typeof balance === 'number'
      ? `$${balance.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : '$0.00';


     




  return (
    <nav style={styles.nav}>
      {/* Logo */}
      <Link to="/">
        <img
          src="/spectra-logo.jpg"
          alt="Spectra Market Analyzer"
          style={styles.logo}
        />
      </Link>

       

       

      
      {/* Right side */}
      <div style={styles.rightSide}>
        {/* Balance Display */}
          <div style={{ ...styles.balance,color: `hsl(${hue}, 100%, 60%)`
}} >

          Balance: <strong>{formattedBalance}</strong>
        </div>

     

                  {/* User Icon */}
<div style={{ position: 'relative', marginLeft: '16px' }}>
  <FaUserCircle
    size={32}
    color={`hsl(${hue}, 100%, 60%)`}
    onClick={toggleUserMenu}
    style={{
      cursor: 'pointer',
      filter: `drop-shadow(0 0 6px hsl(${hue}, 100%, 60%))`
    }}
  />

  <div style={{
    ...styles.userDropdown,
    opacity: userMenuOpen ? 1 : 0,
    pointerEvents: userMenuOpen ? 'auto' : 'none',
    transition: 'opacity 0.35s ease',
  }}>
    <div
      onClick={handleLogout}
      style={{
        ...styles.dropdownLink,
        color: `hsl(${hue}, 100%, 60%)`,
        textShadow: `0 0 6px hsl(${hue}, 100%, 60%)`,
        cursor: "pointer",
      }}
    >
      Logout
    </div>
  </div>
</div>

         
         {/* Hamburger Menu */}
<div style={{ marginLeft: '16px', position: 'relative' }}>
       <img
  src="/file_00000000412471fd88cc0b92908cfa87.png"   // <-- use exact filename from public folder
  alt="Menu"
  onClick={toggleMenu}
  style={{
    height: "52px",
    width: "52px",
    cursor: "pointer",

    transform: menuOpen
      ? "rotate(20deg) scale(1.05)"
      : "rotate(0deg) scale(1)",

    transition: "transform 0.35s ease, filter 0.1s linear",

    filter: `
      hue-rotate(${hue}deg)
      drop-shadow(0 0 6px hsl(${hue}, 100%, 60%))
    `,
  }}
/>

  
  {menuOpen && (
    <div style={styles.menuDropdown}>

      <div
  style={{
  ...styles.dropdownLink,
  color: `hsl(${hue}, 100%, 60%)`,
  textShadow: `0 0 6px hsl(${hue}, 100%, 60%)`,
}}

  onClick={() => handleNavigation("/")}
>
        Dashboard
      </div>

<div
  style={{
  ...styles.dropdownLink,
  color: `hsl(${hue}, 100%, 60%)`,
  textShadow: `0 0 6px hsl(${hue}, 100%, 60%)`,
}}

  onClick={() => handleNavigation("/banking")}
>
        Banking
      </div>

<div
  style={{
  ...styles.dropdownLink,
  color: `hsl(${hue}, 100%, 60%)`,
  textShadow: `0 0 6px hsl(${hue}, 100%, 60%)`,
}}

  onClick={() => handleNavigation("/transactions")}
>
        Transactions
      </div>

   <div
  style={{
  ...styles.dropdownLink,
  color: `hsl(${hue}, 100%, 60%)`,
  textShadow: `0 0 6px hsl(${hue}, 100%, 60%)`,
}}

  onClick={() => handleNavigation("/analytics")}
>
        Analytics
      </div>

   <div
  style={{
  ...styles.dropdownLink,
  color: `hsl(${hue}, 100%, 60%)`,
  textShadow: `0 0 6px hsl(${hue}, 100%, 60%)`,
}}

  onClick={() => handleNavigation("/settings")}
>
        Settings
      </div>

    </div>
  )}
</div>

          
        
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#000',
    padding: '16px',
  },
  logo: {
    height: '60px',
  },
  rightSide: {
    display: 'flex',
    alignItems: 'center',
  },
  balance: {
    fontWeight: 'bold',
    fontSize: '16px',
  },
  menuDropdown: {
    position: 'absolute',
    top: '40px',
    right: 0,
    background: 'rgba(15,15,15,0.95)',
    padding: '8px 0',
    borderRadius: '6px',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '150px',
    zIndex: 10,
  },
  userDropdown: {
    position: 'absolute',
    top: '40px',
    right: 0,
    background: 'rgba(15,15,15,0.95)',
    padding: '8px 0',
    borderRadius: '6px',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '120px',
    zIndex: 10,
  },
 dropdownLink: {
  padding: '8px 16px',
  textDecoration: 'none',
  fontWeight: 'bold',
  cursor: 'pointer',
  transition: 'color 0.05s linear, text-shadow 0.05s linear',
},

};

